import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  FileUploadModalBaseComponent
} from '../../shared/components/file-upload-modal/file-upload-modal-base.component';

import { NotificationService, TransactionsService } from '../../shared/services';
import { ModalService } from '../../shared/modules/modal';

import { TranslationConstants } from '../../shared/constants';

@Component({
  selector: 'import-transactions-modal',
  templateUrl: './import-transactions-modal.component.html',
})
export class ImportTransactionsModalComponent extends FileUploadModalBaseComponent {

  constructor(
    private _transactionsService: TransactionsService,
    protected notificationService: NotificationService,
    protected modalService: ModalService,
    protected translate: TranslateService
  ) {
    super(notificationService, modalService, translate);
  }
  public isValid: boolean = true;
  upload(): void {
    if (this.fileTypeInvalid) {
      return;
    }

    this.resetErrors();
    // if upload started or no file, do not trigger the API again
    if (this.showLoader || !this.fileToUpload) {
      return;
    }
    this.columns = [];
    this.showLoader = true;
    this._transactionsService.uploadImportTransactionsFile(this.fileToUpload).subscribe(({ data }) => {

      if (data && data.headers) {
        this.columns = data.headers.map((header: string) => { return { header }; });
      }
      this.allowedFields = data.allowed;
      this.filteredAllowedFields = data.allowed;
      this.fileHash = data.hash;
      this.showLoader = false;
      this.uploaded = true;
      this.handleDefaultFieldsForHeaders();
      this.validateColumns();
    });
  }
  startImport(): void {
    this.responseErrors = [];
    // if import started, do not trigger the API again
    if (this.showLoader) {
      return;
    }
    const payload = this.prepareImportPayload();
    if (payload.mappings.length === 0) {
      this.responseErrors.push(TranslationConstants.ERROR_IMPORT_NO_MAPPING);
      return;
    }

    this.showLoader = true;
    this._transactionsService.submitMappings(payload).subscribe(() => {
      this.showLoader = false;
      this.closeAllModals();
      this.success();
    });
  }

  validateColumns(): void {
    this.isValid = true;
    if (this.allowedFields.length !== this.columns.length) {
      this.isValid = false;
      this.responseErrors.push(TranslationConstants.ERROR_IMPORT_MISMATCH_COLUMNS);
    }
    const validFields = {};
    this.allowedFields.forEach((field) => {
      validFields[field.defaultHeader] = true;
    });
    this.columns.forEach((column) => {
      if (!validFields[column.header]) {
        column.error = TranslationConstants.ERROR_IMPORT_INVALID_COLUMN_NAME;
        this.isValid = false;
      }
    });
  }
}

